"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessSelectionModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const polaris_1 = require("@amzn/awsui-components-react/polaris");
const CONSTANTS = __importStar(require("../../common/constants"));
const process_helpers_1 = require("../../common/process_helpers");
const react_arb_tools_1 = require("@amzn/react-arb-tools");
function NoAuthorizedProcessesAlert() {
    const process = (0, process_helpers_1.useProcess)();
    const [localeBundle] = (0, react_arb_tools_1.useBundle)(CONSTANTS.STRINGS_NAMESPACE);
    const [bundleLoaded, setBundleLoaded] = react_1.default.useState(false);
    (0, react_1.useEffect)(() => {
        if (localeBundle !== undefined) {
            setBundleLoaded(true);
        }
    });
    if (!process.isProcessesLoading && process.processes.length === 0) {
        const warningMessage = localeBundle !== undefined
            ? localeBundle.formatMessage('no-authorized-processes-warning-message', {
                wikiLink: CONSTANTS.AUTHZ_DOCUMENTATION_WIKI_LINK,
            })
            : `You are not authorized to view any process. Please contact the owners of the process you want to view to request permission. Refer to ${CONSTANTS.AUTHZ_DOCUMENTATION_WIKI_LINK} for more details.`;
        return (0, jsx_runtime_1.jsx)(polaris_1.Alert, { type: "warning", children: warningMessage });
    }
    else {
        return null;
    }
}
const ProcessSelectionModal = () => {
    const process = (0, process_helpers_1.useProcess)();
    const [processSelectorModalVisible, setProcessSelectorModalVisible] = (0, react_1.useState)(process.selectedProcess == CONSTANTS.PROCESS_PLACEHOLDER);
    return ((0, jsx_runtime_1.jsx)(polaris_1.Modal, { visible: processSelectorModalVisible, closeAriaLabel: "Close modal", children: (0, jsx_runtime_1.jsxs)(polaris_1.SpaceBetween, { direction: "vertical", size: "l", children: ["Please select a process before accessing EDM UI", (0, jsx_runtime_1.jsx)(polaris_1.Box, { float: "right", children: (0, jsx_runtime_1.jsx)(polaris_1.ButtonDropdown, { items: process.processes.map((process) => {
                            return { text: process, id: process };
                        }), loading: process.isProcessesLoading, onItemClick: (event) => {
                            process.onSelectedProcessChange(event.detail.id);
                            setProcessSelectorModalVisible(false);
                        }, children: "Processes" }) }), (0, jsx_runtime_1.jsx)(NoAuthorizedProcessesAlert, {})] }) }));
};
exports.ProcessSelectionModal = ProcessSelectionModal;
